import request from '@/utils/request'

// 获取玻片的题
export function getSlidePaper() {
	return request({
		url: '/exam/getSlidePaper',
		method: 'get'
	})
}

// 获取诊疗思路的题
export function getPetPaper() {
	return request({
		url: '/exam/getPetPaper',
		method: 'get'
	})
}

// 检查答案
export function checkAnswer(data) {
	return request({
		url: '/exam/checkAnswer',
		method: 'post',
		data
	})
}

// 获取病例记录
export function getCaseRecord(data) {
	return request({
		url: '/exam/getCaseRecord',
		method: 'post',
		data: data
	})
}

// 获取我的考题及对应答案
export function getPaperAndAnswer() {
	return request({
		url: '/exam/getPaperAndAnswer',
		method: 'get'
	})
}

// 获取其他考题及对应答案
export function getOtherPaperAndAnswer() {
	return request({
		url: '/exam/getOtherPaperAndAnswer',
		method: 'get'
	})
}

// 获取诊疗考核结果
export function getPetScore() {
	return request({
		url: '/exam/getPetScore',
		method: 'get'
	})
}

// 获取显微镜答案展示
export function getSlideAnswer() {
	return request({
		url: '/exam/getSlideAnswer',
		method: 'get'
	})
}

// 获取显微镜考核结果
export function getSlideScore() {
	return request({
		url: '/exam/getSlideScore',
		method: 'get'
	})
}

// 获取显微镜其他考题及对应答案
export function getSlideOtherPaperAndAnswer() {
	return request({
		url: '/exam/getSlideOtherPaperAndAnswer',
		method: 'get'
	})
}

// 获取总成绩
export function getSummaryScore() {
	return request({
		url: '/exam/getSummaryScore',
		method: 'get'
	})
}

// 提交诊疗作答
export function submitPetAnswer(data) {
	return request({
		url: '/exam/submitPetAnswer',
		method: 'post',
		data
	})
}

// 提交显微镜作答
export function submitSlideAnswer(data) {
	return request({
		url: '/exam/submitSlideAnswer',
		method: 'post',
		data
	})
}

// 获取考核是否结束
export function isEnd() {
	return request({
		url: '/exam/isEnd',
		method: 'get'
	})
}

// 获取最高分数接口
export function getHighestSummaryScore() {
	return request({
		url: '/exam/getHighestSummaryScore',
		method: 'get'
	})
}

// 获取用户信息
export function getIndexUserData() {
	return request({
		url: '/exam/getIndexUserData',
		method: 'get'
	})
}

// 清除当前这个人的信息
export function cleanMyExamData() {
	return request({
		url: '/exam/cleanMyExamData',
		method: 'get'
	})
}
// 查询额外考试次数
export function examExtractQueryExtraTimes() {
	return request({
		url: '/exam/extract/queryExtraTimes',
		method: 'get'
	})
}

// 暂停
export function examPauseExam() {
	return request({
		url: '/exam/pauseExam',
		method: 'get'
	})
}
// 重新开始
export function examRestartExam() {
	return request({
		url: '/exam/restartExam',
		method: 'get'
	})
}
// 提交单个题目
export function submitExamCommitSingerAnswer(data) {
	return request({
		url: '/exam/commitSingerAnswer',
		method: 'post',
		data
	})
}